import React, { useContext, useEffect, useReducer } from 'react';
import type { Editor } from '@tiptap/core';

// Null outside the floating toolbar, which is how the shared tool components
// tell the tiptap path from the legacy DOM-range path.
export const TiptapEditorContext = React.createContext<Editor | null>(null);

export function useTiptapEditor() {
	return useContext(TiptapEditorContext);
}

// Re-render the caller on every transaction so active state and the current
// font family / size follow the caret.
export function useTiptapEditorSync(editor: Editor | null) {
	const [, bump] = useReducer((n: number) => n + 1, 0);
	useEffect(() => {
		if (!editor) return;
		editor.on('transaction', bump);
		return () => {
			editor.off('transaction', bump);
		};
	}, [editor]);
}
